import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomDatePicker } from '../../../../../components/CustomDatePicker';
import { CustomTextField } from '../../../../../components/CustomTextField';
import CreateUpdateRequest from '../Functionality/CreateUpdateRequest';
import CustomModal from './../../../../../components/Modal/CustomModal';
import React from "react";
import {
    CleanIcon,
    InfoChip,
    PersonChipBlack
} from "../../../../../components/buttons/IconButtons";
import CustomMediumChip from "../../../../../components/CustomMediumChip";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import CustomUserChip from "../../../../../components/CustomUserChip";
import ExtraMealTypeSection from "./ExtraMealTypeSection";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";
import {EXTRA_MEAL_TYPE_MODEL} from "../Model/Models";
import {CustomSelect} from "../../../../../components/CustomSelect";
/**
 * @Author: Arnulfo ferro
 * @JobTitle : Frontend
 * @Email : azapata@ibl.mx
 *
 */
const RequestMealModal = (props) => {
    const { t } = useTranslation();
    const { showRequestModal,onHide, itemSelected, setModified, userId, extraMealType } = props;

    const {
        item,
        handleChange,
        handleAddUpdate,
        emptyFields,
        isMealNumberValid,
        handleHide,
        selectedList,
        setSelectedList,
        disabledNumberMeals,
        isUpdate,
        foodieApproval,
        clearFields,
        cleanChipSearch,
        setCleanChipSearch,
        mealtimes,
        getBodyApi,
        apiSearchEmployee
    } = CreateUpdateRequest(
        onHide,
        t,
        itemSelected,
        setModified,
        extraMealType
    );

    return (
        <CustomModal
            title={isUpdate ? 'update_meal_request' : 'request_a_new_meal'}
            show={showRequestModal}
            size={'lg'}
            buttonConfirm='confirm'
            cancelButton={true}
            onConfirm={handleAddUpdate}
            onHide={handleHide}
            classNameBody="pt-2"
        >
            <div className='row'>
                { !isUpdate &&
                    <div className='col-12'>
                        <div className={"d-flex justify-content-end mb-3"}>
                            <ButtonIcon
                                id='btn_rmm_clean_fields'
                                Icon={CleanIcon}
                                onClick={clearFields}
                                title={'clear_instances'}
                                className={'btn-clean-secondary-600'}
                                tooltipPlacement={'right'}
                                iconProps='btn-icon-svg-12px icon-color-general-00'
                            />
                        </div>

                    </div>
                }
                {
                    foodieApproval?.reason &&
                    <div className={"col-12 mb-4"}>
                        <CustomUserChip
                            className="mt-0 chip-warning-150-100 justify-content-start d-flex my-3"
                            name={foodieApproval?.reason}
                            Icon={InfoChip}
                            showAvatar={true}
                            classNameIcon={"icon-color-warning-700"}
                            variant="large"
                            iconPosition={POSITION_MODEL.LEFT}
                        />
                    </div>
                }

                <div className={"col-12"}>
                    <CustomDatePicker
                        id='dp_rmm_select_day'
                        name='select_day'
                        trans='cafeteria_serving_date'
                        required={true}
                        disablePast={true}
                        openTo='day'
                        emptyFields={emptyFields}
                        value={item?.servingDate || null}
                        onChange={(e) =>
                            handleChange({
                                target: { name: 'servingDate', value: e },
                            })
                        }
                    />
                </div>

                <div className="col-12">
                    <CustomSelect
                        id={"slt_rmm_mealtime_id"}
                        name="mealTimeId"
                        trans="service_time"
                        list={mealtimes || []}
                        showNoSelectionOption={true}
                        keyName={"id"}
                        onChange={handleChange}
                        required={false}
                        value={item?.mealTimeId || ''}
                    />
                </div>

                {!item.id && extraMealType === EXTRA_MEAL_TYPE_MODEL.PERSONAL &&
                    <div className={'col-12'}>
                        <CustomTextField
                            id='txt_rmm_number_of_meals'
                            name='mealsNumber'
                            trans='number_of_meals'
                            type='number'
                            value={item?.mealsNumber ?? ''}
                            required={true}
                            onChange={handleChange}
                            inputProps={{ max: 99, min: 1 }}
                            showCounter={true}
                            length={2}
                            isValid={isMealNumberValid}
                            isValidText={'extra_meals_per_day'}
                            helperText={'extra_meals_per_day'}
                            emptyFields={emptyFields}
                            disabled={disabledNumberMeals}
                        />
                    </div>
                }

                {
                    isUpdate ?
                        <>
                            { selectedList.length > 0 && (selectedList[0].id !== userId ) &&
                            <>
                                <Box className='col-12 d-flex justify-content-center mb-4'>
                                    <span className='font-color-text-950 ibl-font-w-700 ibl-ientry-p text-uppercase'>
                                        {t('assigned_employee')}
                                    </span>
                                </Box>
                                <div className={`maxh-155px overflow-y-auto d-flex gap-4 input-padding-bottom flex-wrap`}>
                                    {selectedList.map((element) => (
                                        <CustomMediumChip
                                            key={element.id}
                                            title={element.label}
                                            completeWidth={false}
                                            disabled={true}
                                            showAvatar={true}
                                            Icon={PersonChipBlack}
                                            iconPosition={POSITION_MODEL.LEFT}
                                        >
                                            {element?.subSection?.() && (
                                                <div
                                                    className='mt-2 d-flex w-100 align-items-center align-content-center justify-content-between'>
                                                    {element?.subSection?.()}
                                                </div>
                                            )}
                                        </CustomMediumChip>
                                    ))}
                                </div>
                            </>
                            }
                        </>
                        :
                        <ExtraMealTypeSection
                            extraMealType={extraMealType}
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            emptyFields={emptyFields}
                            cleanChipSearch={cleanChipSearch}
                            setCleanChipSearch={setCleanChipSearch}
                            getBodyApi={getBodyApi}
                            apiSearchEmployee={apiSearchEmployee}
                        />
                }

                <Box className='col-12 d-flex justify-content-center mb-4'>
                    <span className='font-color-text-950 ibl-font-w-700 ibl-ientry-p text-uppercase'>
                        {t('please_provide_reason')}
                    </span>
                </Box>

                <div className='col-sm-12'>
                    <CustomTextField
                        id='txt_rmm_description'
                        name='description'
                        trans='description'
                        length={512}
                        multiline
                        rows={3}
                        required={true}
                        value={item?.description || ''}
                        onChange={handleChange}
                        emptyFields={emptyFields}
                    />
                </div>
            </div>
        </CustomModal>
    );
};
export default RequestMealModal;
